import React from "react";
import { Button, Input } from "antd";
import { logoWhite } from "../../../commons/PanelImagepath";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../../normalUsers/components/login/AuthPage.css";

const ForgotPassword = () => {
  const { t } = useTranslation("dashboard");
  const config = "/";
  return (
    <main className="auth-page auth-page--embedded">
      <div className="auth-page__card">
        <div className="auth-page__brand">
          <img src={logoWhite} alt="LeistFusion" />
        </div>
        <div className="auth-page__body">
          <h1 className="auth-page__title">{t("Forgot Password?")}</h1>
          <p className="auth-page__subtitle">
            {t("Enter your email to get a password reset link")}
          </p>
          <form className="auth-page__form" action={`${config}admin/login`}>
            <Input
              size="large"
              type="email"
              inputMode="email"
              autoComplete="email"
              autoCapitalize="none"
              spellCheck={false}
              placeholder={t("Email")}
              aria-label={t("Email")}
            />
            <Button
              className="auth-page__submit"
              type="primary"
              htmlType="submit"
              size="large"
              block
            >
              {t("Reset Password")}
            </Button>
          </form>
          <div className="auth-page__switch">
            {t("Remember your password?")} <Link to="/login">{t("Login")}</Link>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ForgotPassword;
